import siteInfo from './config';

export const siteNav = {};

for (let language of siteInfo.languages) {
    siteNav[language] = require(`../../content/${language}/nav.yml`);
}
